import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PaymentHandlingAndroid from './_primerSettings/paymentHandling.mdx';
import PaymentMethodOptions from './_primerSettings/paymentMethodOptions.mdx';
import PrimerUIOptions from './_primerSettings/uiOptions.mdx';
import PrimerDebugOptions from './_primerSettings/debugOptions.mdx';
import ClientSessionCachingEnabledAndroid from './_primerSettings/clientSessionCachingEnabled.mdx';
import ApiVersionAndroid from './_primerSettings/apiVersion.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`⚠️ If no settings are provided, the SDK will initialize with its default settings. `}<br />{`
Use `}<inlineCode parentName="p">{`PrimerSettings`}</inlineCode>{` to provide different options based on your use case.`}</p>
    <Group mdxType="Group">
	<Item title='paymentHandling' subtitle='PrimerPaymentHandling' label='Default: PrimerPaymentHandling.AUTO' mdxType="Item">
		<PaymentHandlingAndroid mdxType="PaymentHandlingAndroid" />
	</Item>
	<Item title='locale' subtitle='Locale' mdxType="Item">
		Force the SDK locale. By default, the locale will be set to the device's locale.
	</Item>
	<Item title='paymentMethodOptions' subtitle='PrimerPaymentMethodOptions' mdxType="Item">
		<Group mdxType="Group">
			<PaymentMethodOptions mdxType="PaymentMethodOptions" />
		</Group>
	</Item>
	<Item title='uiOptions' subtitle='PrimerUIOptions' mdxType="Item">
		Sets the different UI options in the SDK.
		<Group open summary='Properties' mdxType="Group">
			<PrimerUIOptions mdxType="PrimerUIOptions" />
			<Item title='cardFormUIOptions' subtitle='PrimerCardFormUIOptions?' mdxType="Item">
				Configure the card form UI options.
				<Group open summary='Properties' mdxType="Group">
					<Item title='payButtonAddNewCard' subtitle='Boolean' mdxType="Item">
						When set to true, the Drop-In's card form toolbar and pay button will show "Add new card"; otherwise it will show "Pay $x.xx".
					</Item>
				</Group>
			</Item>
		</Group>
	</Item>
	<Item title='debugOptions' subtitle='PrimerDebugOptions' mdxType="Item">
		Sets the different debug options in the SDK.
		<Group open summary='Properties' mdxType="Group">
			<PrimerDebugOptions mdxType="PrimerDebugOptions" />
		</Group>
	</Item>
	<Item title='clientSessionCachingEnabled' subtitle='Boolean' label='Default: false' mdxType="Item">
		<ClientSessionCachingEnabledAndroid mdxType="ClientSessionCachingEnabledAndroid" />
	</Item>
	<Item title='apiVersion' subtitle='PrimerApiVersion' label='Default: PrimerApiVersion.V2_3' mdxType="Item">
		<ApiVersionAndroid mdxType="ApiVersionAndroid" />
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      